import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import {List, Flex, NavBar, Icon} from 'antd-mobile'
import df from 'dateformat'
import _ from 'lodash'
let page = 1;
// let queryValue = "";
class farmOrgList extends Component {
  constructor(props) {
    super(props);
    // 用于交互数据
    this.state = {
      refreshing: false,
      down: false,
      // 导航高度: 45, 搜索高度: 44, 子项名: 45
      height: window.HEIGHT - 78,
      modalData: [],
      sumCount: 0,
      showIndex: 0
    }
  }
  getNextPageData = () => {
    console.log(this.state.sumCount, this.state.modalData.length);
    if (this.state.sumCount >= this.state.modalData.length) {
      page++;
      this.getData(page);
      this.setState({
        refreshing: true
      })
    }
  };
  componentDidMount() {
    const _self = this;
    _self.listenScroll = _.debounce(function (showIndex) {
      _self.setState({
        showIndex
      })
    }, 100);
    // 滚动到当前选择位置。
    const {current,data} = _self.props;
    let index = data.findIndex(o => o.mateGroup === current);
    ReactDOM.findDOMNode(this.refs['mateGroup']).scrollTop = index * 40;
  }
  render() {
    const { current, id, data } = this.props;
    return (
      <React.Fragment>
        <NavBar mode="light">配种组列表</NavBar>
        <List
            renderHeader={() => (
            <Flex>
              <span style={{width: 60}}>配种组</span>
              <Flex.Item>开始日期</Flex.Item>
              <Flex.Item>截止日期</Flex.Item>
            </Flex>
          )}
        >
          <div
              style={{
              height: this.state.height,
              padding: '0 15px',
              overflow: 'auto'
            }}
              ref={'mateGroup'}
              onScroll={v => {
              let showIndex = Math.floor((v.target.scrollTop) / 40);
              this.listenScroll(showIndex)
            }}
          >
            {data && data.map((item, index) => {
              if (index >= this.state.showIndex && index <= this.state.showIndex + 15) {
                return <Flex key={index}
                    style={{height: 40,lineHeight: 40}}
                    onClick={() => this.props.selectItem(item, id)}
                       >
                  <span  style={{width: 60}}>{item.mateGroup}</span>
                  <Flex.Item>{df(item.weekStartDate, 'yyyy-mm-dd')}</Flex.Item>
                  <Flex.Item>{df(item.weekEndDate, 'yyyy-mm-dd')}</Flex.Item>
                  <Icon color="#108EE9"
                        type={current === item.mateGroup?'check': ''}
                  />
                </Flex>
              } else {
                return <div key={index}
                    style={{height: 40}}
                       >--</div>
              }
            })}
          </div>
        </List>
      </React.Fragment>
    )
  }
}
export default farmOrgList
